import {
  CustomBodyCell,
  CustomHeaderCell,
  CustomTable,
  CustomTableContainer,
  CustomTableRow,
} from '@components/Styles/TableStyle';
import { CustomTextField, RequiredMark, RequiredMarkBox, SectionWrapper } from '@components/Styles/CommonStyle';

import CustomInput from '@components/common/Input/CustomInput';
import { CustomStack } from '@components/Styles/CommonStyle';
import React from 'react';
import { TableBody } from '@mui/material';
import { Typography } from '@mui/material';
import { theme } from '@components/Styles/theme';

const FreeAccountCreateTable = ({ param, setParam }) => {
  // 파일 찾기
  const handleFileChange = (event) => {
    const file = event.target.files[0];

    // 신분증
    if (event.target.name === 'identityFile') {
      console.log('신분증');
      console.log(file);

      setParam({ ...param, identityFile: file });
    }
    // 통장사본
    else if (event.target.name === 'bankbookFile') {
      console.log('통장사본');
      console.log(file);

      setParam({ ...param, bankbookFile: file });
    }
  };

  return (
    <React.Fragment>
      <CustomStack mb={2}>
        <Typography sx={theme.typography.h4}>프리랜서 등록</Typography>
      </CustomStack>
      <SectionWrapper>
        <CustomStack justifyContent="spaceBetween" mb={2}>
          <Typography sx={theme.typography.h4}>프리랜서 정보</Typography>
          <RequiredMarkBox>
            <RequiredMark />
            (&nbsp;&nbsp;) 필수입력사항
          </RequiredMarkBox>
        </CustomStack>
        <CustomTableContainer>
          <CustomTable fourColumn>
            <TableBody>
              <CustomTableRow>
                <CustomHeaderCell>
                  <RequiredMark />
                  성명
                </CustomHeaderCell>
                <CustomBodyCell>
                  <CustomTextField
                    value={param.personName}
                    onChange={(e) => setParam({ ...param, personName: e.target.value })}
                  />
                </CustomBodyCell>
                <CustomHeaderCell>
                  <RequiredMark />
                  휴대전화
                </CustomHeaderCell>
                <CustomBodyCell>
                  <CustomTextField
                    value={param.phone}
                    onChange={(e) => {
                      const value = e.target.value;
                      // 숫자만 허용 (빈 문자열도 허용해서 백스페이스 가능)
                      if (/^\d*$/.test(value)) {
                        setParam({ ...param, phone: value });
                      }
                    }}
                  />
                </CustomBodyCell>
              </CustomTableRow>
              <CustomTableRow>
                <CustomHeaderCell>이메일</CustomHeaderCell>
                <CustomBodyCell>
                  <CustomTextField
                    value={param.email}
                    onChange={(e) => setParam({ ...param, email: e.target.value })}
                  />
                </CustomBodyCell>
                <CustomHeaderCell>신분증</CustomHeaderCell>
                <CustomBodyCell>
                  <CustomStack>
                    <CustomInput
                      type="file"
                      onChange={handleFileChange}
                      name="identityFile"
                      sx={{ '& .MuiInputBase-root': { width: 'calc(100% - 68px)' } }}
                    />
                  </CustomStack>
                  <CustomStack>
                    {/* 신분증 파일 */}
                    {param?.identityFile && param?.identityFile instanceof File && '[파일 업로드]'}
                    {param?.identityFile &&
                      !(param?.identityFile instanceof File) &&
                      param?.identityFile !== '/uploads/null' &&
                      '[현재 파일 : ' + param?.identityFile + ']'}
                  </CustomStack>
                </CustomBodyCell>
              </CustomTableRow>
              <CustomTableRow>
                <CustomHeaderCell>통장사본</CustomHeaderCell>
                <CustomBodyCell>
                  <CustomStack>
                    <CustomInput
                      type="file"
                      onChange={handleFileChange}
                      name="bankbookFile"
                      sx={{ '& .MuiInputBase-root': { width: 'calc(100% - 68px)' } }}
                    />
                  </CustomStack>
                  <CustomStack>
                    {/* 통장사본 파일 */}
                    {param?.bankbookFile && param?.bankbookFile instanceof File && '[파일 업로드]'}
                    {param?.bankbookFile &&
                      !(param?.bankbookFile instanceof File) &&
                      param?.bankbookFile !== '/uploads/null' &&
                      '[현재 파일 : ' + param?.bankbookFile + ']'}
                  </CustomStack>
                </CustomBodyCell>
                <CustomHeaderCell>계좌번호</CustomHeaderCell>
                <CustomBodyCell>
                  <CustomStack>
                    <CustomTextField
                      placeholder="은행명"
                      value={param.bank}
                      onChange={(e) => setParam({ ...param, bank: e.target.value })}
                    />
                    <CustomTextField
                      placeholder="계좌번호"
                      value={param.accountNumber}
                      onChange={(e) => setParam({ ...param, accountNumber: e.target.value })}
                    />
                  </CustomStack>
                </CustomBodyCell>
              </CustomTableRow>
            </TableBody>
          </CustomTable>
        </CustomTableContainer>
      </SectionWrapper>
    </React.Fragment>
  );
};

export default FreeAccountCreateTable;
